import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import NotificationSettingsModal from '../../components/notifications/Settings';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';
import NotifierApp from 'components/NotifierApp';
import { logToAmplitude } from '../../helpers/logAmplitudeEvent';

const DownloadOpusNotifierApp: React.FC = () => {
  useEffect(() => {
    logToAmplitude('Download Opus Notifier App Page Visited');
  }, []);

  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title="Download Opus Notifier App" />

      <NotificationSettingsModal />

      <NotifierApp />

      <BackToTop />
      <Footer />
    </>
  );
};

export default DownloadOpusNotifierApp;
